(function () {
  'use strict';
  function qs(selector, scope) { return (scope || document).querySelector(selector); }
  function qsa(selector, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }

  function initHeroSlider(hero) {
    if (!hero || hero.dataset.goReady === 'true') return;
    hero.dataset.goReady = 'true';
    var slides = qsa('[data-ne-slide]', hero);
    var dots = qsa('[data-ne-hero-dot]', hero);
    var previous = qs('[data-ne-hero-prev]', hero);
    var next = qs('[data-ne-hero-next]', hero);
    var index = 0;
    var timer;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = hero.dataset.autoplay === 'true' && !reduceMotion && slides.length > 1;
    var speed = Math.max(4000, Number(hero.dataset.speed) || 6000);
    function show(newIndex) {
      if (!slides.length) return;
      index = (newIndex + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function start() { stop(); if (autoplay) timer = window.setInterval(function () { show(index + 1); }, speed); }
    if (previous) previous.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { show(Number(dot.dataset.neHeroDot)); start(); }); });
    hero.setAttribute('tabindex', '0');
    hero.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { show(index - 1); start(); }
      if (event.key === 'ArrowRight') { show(index + 1); start(); }
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    show(0); start();
  }

  function initMenu() {
    var menuToggle = qs('[data-menu-toggle]');
    var menu = qs('[data-kp-menu]');
    if (!menuToggle || !menu) return;
    function closeMenu() {
      menu.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      var icon = qs('span', menuToggle); if (icon) icon.textContent = '☰';
    }
    menuToggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(open));
      var icon = qs('span', menuToggle); if (icon) icon.textContent = open ? '×' : '☰';
    });
    qsa('a', menu).forEach(function (link) { link.addEventListener('click', closeMenu); });
    document.addEventListener('click', function (event) {
      if (menu.classList.contains('is-open') && !menu.contains(event.target) && !menuToggle.contains(event.target)) closeMenu();
    });
  }

  function initWheel() {
    var modal = qs('[data-wheel-modal]');
    if (!modal || modal.dataset.goReady === 'true') return;
    modal.dataset.goReady = 'true';
    var card = qs('[data-wheel-card]', modal);
    var wheel = qs('[data-wheel-spin]', modal);
    var spinButton = qs('[data-wheel-spin-button]', modal);
    var result = qs('[data-wheel-result]', modal);
    var resultTitle = qs('[data-wheel-result-title]', modal);
    var resultCode = qs('[data-wheel-result-code]', modal);
    var email = qs('[data-wheel-email]', modal);
    var error = qs('[data-wheel-error]', modal);
    var data = qs('[data-wheel-prizes]', modal);
    var prizes = [];
    var previousActive;
    try { prizes = JSON.parse(data ? data.textContent : '[]'); } catch (ignore) { prizes = []; }

    function openWheel() {
      previousActive = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('is-locked');
      var close = qs('[data-wheel-close]', modal); if (close) close.focus();
    }
    function closeWheel() {
      modal.hidden = true;
      document.body.classList.remove('is-locked');
      markSeen();
      if (previousActive && previousActive.focus) previousActive.focus();
    }
    function markSeen() { try { window.localStorage.setItem('gaunidhi-wheel-seen', '1'); } catch (ignore) {} }
    function hasSeen() { try { return window.localStorage.getItem('gaunidhi-wheel-seen') === '1'; } catch (ignore) { return false; } }
    function validEmail() {
      if (!email) return true;
      if (email.checkValidity()) { if (error) error.textContent = ''; return true; }
      if (error) error.textContent = 'Please enter a valid email address to unlock the wheel.';
      email.focus(); return false;
    }
    function captureEmail() {
      var form = qs('[data-wheel-form]', modal);
      if (!form || form.dataset.submitted === 'true') return;
      form.dataset.submitted = 'true';
      fetch(form.action, { method: 'POST', headers: { 'Accept': 'text/html' }, body: new FormData(form) }).catch(function () {});
    }
    function spinWheel() {
      if (!wheel || wheel.classList.contains('is-spinning') || !validEmail()) return;
      var winner = prizes.length ? Math.floor(Math.random() * prizes.length) : 0;
      var segment = prizes.length ? 360 / prizes.length : 60;
      var rotation = 1800 + (360 - (winner * segment + segment / 2));
      wheel.style.setProperty('--wheel-rotation', rotation + 'deg');
      wheel.classList.add('is-spinning');
      captureEmail();
      if (spinButton) { spinButton.disabled = true; spinButton.textContent = 'Spinning…'; }
      if (error) error.textContent = '';
      window.setTimeout(function () {
        var prize = prizes[winner] || { result: 'Your offer is ready!', code: 'GAUNIDHI15' };
        wheel.classList.remove('is-spinning');
        if (spinButton) spinButton.hidden = true;
        if (email) email.hidden = true;
        if (resultTitle) resultTitle.textContent = prize.result || prize.label;
        if (resultCode) resultCode.textContent = prize.code;
        if (result) result.hidden = false;
        markSeen();
      }, 2200);
    }

    qsa('[data-wheel-open]').forEach(function (button) { button.addEventListener('click', openWheel); });
    qsa('[data-wheel-close]', modal).forEach(function (button) { button.addEventListener('click', closeWheel); });
    modal.addEventListener('click', function (event) { if (event.target === modal) closeWheel(); });
    if (wheel) wheel.addEventListener('click', spinWheel);
    if (spinButton) spinButton.addEventListener('click', spinWheel);
    var wheelForm = qs('[data-wheel-form]', modal);
    if (wheelForm) wheelForm.addEventListener('submit', function (event) { event.preventDefault(); spinWheel(); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeWheel();
      if (event.key === 'Tab' && !modal.hidden && card) {
        var focusable = qsa('button:not([disabled]), a[href], input:not([disabled])', card).filter(function (node) { return !node.hidden; });
        if (!focusable.length) return;
        var first = focusable[0]; var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    if (modal.dataset.autoOpen === 'true' && !hasSeen()) {
      window.setTimeout(openWheel, Math.max(1000, Number(modal.dataset.delay) || 3000));
    }
  }

  function initQuickAdd(scope) {
    qsa('[data-quick-add]', scope || document).forEach(function (form) {
      if (form.dataset.goReady === 'true') return;
      form.dataset.goReady = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = qs('button[type="submit"]', form); var label = qs('[data-add-label]', form); var status = qs('.kp-card-status', form);
        if (!button || button.disabled) return;
        button.disabled = true; if (label) label.textContent = 'Adding…';
        var root = window.GaunidhiOrganic && window.GaunidhiOrganic.root ? window.GaunidhiOrganic.root : '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (response) { if (!response.ok) throw new Error('Unable to add item'); return response.json(); })
          .then(function () { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            qsa('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });
            if (label) label.textContent = '✓ Added to cart';
            if (status) status.textContent = 'Item added. Your cart has been updated.';
          })
          .catch(function () { if (status) status.textContent = 'Adding through the secure cart…'; HTMLFormElement.prototype.submit.call(form); })
          .finally(function () { window.setTimeout(function () { button.disabled = false; if (label) label.textContent = 'Add to cart'; }, 1800); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu(); initWheel(); initQuickAdd(document); qsa('[data-ne-hero]').forEach(initHeroSlider);
  });
  document.addEventListener('shopify:section:load', function (event) {
    initQuickAdd(event.target); qsa('[data-ne-hero]', event.target).forEach(initHeroSlider); if (qs('[data-wheel-modal]', event.target)) initWheel();
  });
})();
